"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpPerformQuestionCard = void 0;
const getScore_1 = __importDefault(require("@opsbase/lib-form/helpers/getScore"));
const isValidAnswer_1 = __importDefault(require("@opsbase/lib-form/helpers/isValidAnswer"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_palette_1 = __importDefault(require("@opsbase/lib-palette"));
const usePerform_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformController/usePerform"));
const usePerformQuestion_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestion"));
const usePerformQuestionActions_1 = __importDefault(require("@opsbase/react-ctrl-perform/PerformQuestionController/usePerformQuestionActions"));
const useAltForSelfLang_1 = __importDefault(require("@opsbase/react-ctrl-self/helpers/useAltForSelfLang"));
const useSelf_1 = require("@opsbase/react-ctrl-self/useSelf");
const useCallforward_1 = __importDefault(require("@opsbase/react-hooks/useCallforward"));
const web_css_1 = __importStar(require("@opsbase/web-css"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const Vertical_1 = __importDefault(require("@opsbase/web-layout/Vertical"));
const Text_1 = __importDefault(require("@opsbase/web-ui/Text"));
const react_1 = __importStar(require("react"));
require("react-quill/dist/quill.snow.css");
const OpPerformQuestionHighlight_1 = __importDefault(require("../OpPerformQuestionHighlight"));
const OpPerformQuestionIndent_1 = __importDefault(require("../OpPerformQuestionIndent"));
const ButtonPane_1 = __importDefault(require("./ButtonPane"));
const InfoPane_1 = __importDefault(require("./InfoPane"));
const IssuePane_1 = __importDefault(require("./IssuePane"));
const NotePane_1 = __importDefault(require("./NotePane"));
const PaneAnswerIcons_1 = __importDefault(require("./PaneAnswerIcons"));
const PaneTitle_1 = __importDefault(require("./PaneTitle"));
const makeQuestionCardClasses = (disabled, stretch) => ({
    root: {
        height: stretch ? '100%' : undefined,
    },
    extraPane: {
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        border: `1px solid ${lib_palette_1.default.LineGrey.main}`,
        padding: '2px 8px 8px 8px',
        borderRadius: 8,
        minHeight: 400,
    },
    disabler: disabled && {
        pointerEvents: 'none',
    },
    skippedMessage: {
        pointerEvents: disabled ? 'none' : undefined,
        backgroundColor: lib_palette_1.default.WhiteSmoke.main,
        padding: 8,
        margin: 8,
    },
});
exports.OpPerformQuestionCard = react_1.default.forwardRef((props, ref) => {
    const { disableChildren, children, highlightSelected = false, hideButtonPane = false, } = props;
    const { submitting, isSubmitted, form, isScoreEnabled, isScorePublic, isPreview, mode } = (0, usePerform_1.default)();
    const { question, selected, answer, isAutoSkipped, rule } = (0, usePerformQuestion_1.default)();
    const hasNotes = !!(answer === null || answer === void 0 ? void 0 : answer.conversationId);
    const [selectedTab, setSelectedTab] = (0, react_1.useState)(hasNotes ? 'comments' : null);
    const self = (0, useSelf_1.useSelf)();
    const viewMode = mode === 'view';
    const isAllowedToSeeScore = (isPreview || viewMode) && (self.isAdmin || self.isPrimary);
    const scoreText = (0, react_1.useMemo)(() => {
        if (isScoreEnabled &&
            (isAllowedToSeeScore || isScorePublic) &&
            (0, isValidAnswer_1.default)(answer, question, rule)) {
            const score = (0, getScore_1.default)(form, question, true);
            if (score === null || score === void 0 ? void 0 : score.max) {
                return `${score.total}/${score.max}`;
            }
        }
        else
            return null;
    }, [isScoreEnabled, isAllowedToSeeScore, isScorePublic, answer, question, rule, form]);
    const { doSelect } = (0, usePerformQuestionActions_1.default)();
    const hasIssue = answer.issue || answer.issueId;
    const stateColor = highlightSelected && selected ? lib_palette_1.default.secondary : undefined;
    const skipped = answer === null || answer === void 0 ? void 0 : answer.notApplicable;
    const myCss = (0, web_css_1.default)(makeQuestionCardClasses, [
        submitting || isSubmitted || disableChildren,
        false,
    ]);
    const toggleShow = (0, useCallforward_1.default)(v => () => {
        setSelectedTab(selectedTab === v ? null : v);
    }, [selectedTab]);
    const [title] = (0, useAltForSelfLang_1.default)(question === null || question === void 0 ? void 0 : question.title, question === null || question === void 0 ? void 0 : question.titleAlt);
    const infoContent = (0, react_1.useMemo)(() => {
        if (selectedTab !== 'info')
            return null;
        return react_1.default.createElement(InfoPane_1.default, { onClickClose: toggleShow(null) });
    }, [selectedTab, toggleShow]);
    const issueContent = (0, react_1.useMemo)(() => {
        if (skipped || selectedTab !== 'issue')
            return null;
        return react_1.default.createElement(IssuePane_1.default, { onClickClose: toggleShow(null) });
    }, [selectedTab, skipped, toggleShow]);
    const commentContent = (0, react_1.useMemo)(() => {
        if (skipped || selectedTab !== 'comments')
            return null;
        return react_1.default.createElement(NotePane_1.default, { onClickClose: toggleShow(null) });
    }, [selectedTab, skipped, toggleShow]);
    return (0, react_1.useMemo)(() => (react_1.default.createElement(Horizontal_1.default, { shrink: true, classes: { root: myCss.root } },
        react_1.default.createElement(OpPerformQuestionIndent_1.default, null),
        react_1.default.createElement(OpPerformQuestionHighlight_1.default, { highlightSelected: highlightSelected, paper: true, color: stateColor, padding: true, grow: true, ref: ref },
            react_1.default.createElement(Vertical_1.default, { paddingY: true },
                react_1.default.createElement(Horizontal_1.default, { shrink: true, gutter: true, onClick: doSelect },
                    react_1.default.createElement(PaneTitle_1.default, { title: title }),
                    react_1.default.createElement(PaneAnswerIcons_1.default, { color: lib_palette_1.default.secondary, scoreText: scoreText })),
                react_1.default.createElement(Pane_1.default, { paddingY: !viewMode, center: true, classes: {
                        root: (0, web_css_1.cx)(skipped && myCss.skippedMessage, disableChildren && myCss.disabler),
                    } }, !skipped ? (children) : (react_1.default.createElement(Text_1.default, null, isAutoSkipped
                    ? lib_i18n_1.default.t('question-auto-skipped')
                    : lib_i18n_1.default.t('question-skipped')))),
                infoContent,
                issueContent,
                commentContent,
                !hideButtonPane && (react_1.default.createElement(ButtonPane_1.default, { showingInfo: selectedTab === 'info', showingIssue: selectedTab === 'issue', showingNotes: selectedTab === 'comments', hasIssue: hasIssue, hasNotes: hasNotes, onClickInfo: toggleShow('info'), onClickIssue: toggleShow('issue'), onClickNotes: toggleShow('comments') })))))), [
        myCss === null || myCss === void 0 ? void 0 : myCss.root,
        myCss === null || myCss === void 0 ? void 0 : myCss.skippedMessage,
        myCss === null || myCss === void 0 ? void 0 : myCss.disabler,
        highlightSelected,
        stateColor,
        ref,
        doSelect,
        title,
        scoreText,
        viewMode,
        skipped,
        disableChildren,
        children,
        isAutoSkipped,
        infoContent,
        issueContent,
        commentContent,
        hideButtonPane,
        selectedTab,
        hasIssue,
        hasNotes,
        toggleShow,
    ]);
});
exports.default = exports.OpPerformQuestionCard;
